import { Checkbox, Tooltip } from "@material-ui/core";
import React, { useEffect, useState } from "react";

const PackInCardboardField = ({updatePackingCardboard, isPack}) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (isPack) {
      setChecked(isPack);
    }
  }, [isPack]);

  const handlerChange = () => {
    updatePackingCardboard(!checked);
    setChecked(!checked);
  };
  return (
    <Tooltip
      title={
        checked
          ? "Снять метку 'Упаковать в картон'"
          : "Активировать метку 'Упаковать в картон'"
      }
    >
      <Checkbox
        size={"small"}
        checked={checked}
        onChange={handlerChange}
        onClick={(e) => e.stopPropagation()}
      />
    </Tooltip>
  );
};

export default PackInCardboardField;